import React from 'react';
import type { IconProps } from '../Icon/types';
/* istanbul ignore file */
function IconUserSingleDefault({
  srText,
  size = 'md',
  className = '',
  ...props
}: IconProps) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`;
  return <>{!!srText && <span className='mc-sr-only'>{srText}</span>}<svg xmlns="http://www.w3.org/2000/svg" width={25} height={25} fill="none" viewBox="0 0 24 24" aria-hidden="true" role="img" className={newClassName} {...props}><path fill="currentColor" fillRule="evenodd" d="M12 2.5a4.762 4.762 0 1 0 0 9.524A4.762 4.762 0 0 0 12 2.5M9.143 7.262a2.857 2.857 0 1 1 5.714 0 2.857 2.857 0 0 1-5.714 0" clipRule="evenodd" /><path fill="currentColor" d="M5.333 21.548c0-1.8.705-2.92 1.801-3.639 1.159-.758 2.85-1.123 4.866-1.123 2.017 0 3.708.365 4.866 1.123 1.096.718 1.8 1.84 1.8 3.639a.952.952 0 1 0 1.906 0c0-2.409-1.002-4.145-2.663-5.232-1.6-1.047-3.717-1.435-5.909-1.435s-4.31.388-5.909 1.435c-1.661 1.087-2.662 2.823-2.662 5.232a.952.952 0 1 0 1.904 0" /></svg></>;
}
export default IconUserSingleDefault;